import React, { useState } from "react";

const AttributeEditor = ({ modal, setModal, classPrefix = "attribute" }) => {

    const [selectedAttribute, setSelectedAttribute] = useState("custom_attribute");

    const handleAttributeSelect = (e) => {
        setSelectedAttribute(e.target.value);
    };

   const addSelectedAttribute = () => {
    if (!selectedAttribute) {
        alert("Please select a valid attribute");
        return;
    }

    // Check if the selected attribute is a custom attribute
    const isCustomAttribute = selectedAttribute === "custom_attribute";

    // Check if selectedAttribute exists in wp_ajax.attribute_taxonomies
    const selectedTaxonomyData = wp_ajax.attribute_taxonomies[selectedAttribute];

    if (!isCustomAttribute && !selectedTaxonomyData) {
        alert("Invalid attribute selected");
        return;
    }

    const attributeData = isCustomAttribute
        ? { label: "Custom Attribute", values: "", istax: "no" }
        : {
            label: selectedTaxonomyData.attribute.attribute_label,
            all_attirbute: selectedTaxonomyData.values,
            istax: "yes",
            values: [],
        };

    setModal((prevModal) => ({
        ...prevModal,
        data: {
            ...prevModal.data,
            [isCustomAttribute ? `custom_attribute_${Date.now()}` : selectedAttribute]: attributeData,
        },
    }));
};





    const toggleAttribute = (key, termId) => {
        setModal((prevModal) => {
            const updatedData = { ...prevModal.data };
            const selectedTermIds = updatedData[key].values || [];

            if (selectedTermIds.includes(termId)) {
                updatedData[key].values = selectedTermIds.filter((id) => id !== termId);
            } else {
                updatedData[key].values = [...selectedTermIds, termId];
            }

            return { ...prevModal, data: updatedData };
        });
    };

    const handleAttributeChange = (key, newValue) => {
        setModal((prevModal) => ({
            ...prevModal,
            data: {
                ...prevModal.data,
                [key]: {
                    ...prevModal.data[key],
                    values: newValue,
                },
            },
        }));
    };
    const handleLabelChange = (key, newLabel) => {
        setModal((prevModal) => ({
            ...prevModal,
            data: {
                ...prevModal.data,
                [key]: {
                    ...prevModal.data[key],
                    label: newLabel,
                },
            },
        }));
    };


    const deleteAttribute = (attrKey) => {
        setModal((prevModal) => {
            const updatedData = { ...prevModal.data };
            delete updatedData[attrKey]; // Remove the attribute
            return { ...prevModal, data: updatedData };
        });
    };

    const renderCheckbox = (label, stateKey, key, attribute) => (
        <label>
            <input
                type="checkbox"
                checked={attribute[stateKey] === "yes"}
                onChange={() =>
                    setModal((prevModal) => ({
                        ...prevModal,
                        data: {
                            ...prevModal.data,
                            [key]: {
                                ...prevModal.data[key],
                                [stateKey]: attribute[stateKey] === "yes" ? "no" : "yes",
                            },
                        },
                    }))
                }
            />
            {label}
        </label>
    );

    const getAttributeRowClass = (key) => `${classPrefix}-${key}`;

    return (
        <>
        <div className="add-attribute-dropdown">
                
                <select
    value={selectedAttribute}
    onChange={handleAttributeSelect}
    className="attribute-dropdown"
>
    <option value="custom_attribute">Custom Attribute</option>
    {Object.entries(wp_ajax.attribute_taxonomies).map(([key, attributeData]) => (
        <option key={key} value={attributeData.attribute_key}>
            {attributeData.attribute.attribute_label}
        </option>
    ))}
</select>



                <button
                    className="add-attribute-button"
                    onClick={addSelectedAttribute}
                >
                    Add Attribute
                </button>
            </div>
       
        <table className="attribute-editor-table">
            <thead>
                <tr>
                    <th>Attribute Name</th>
                    <th>Values</th>
                    <th>Visible</th>
                    <th>Variation</th>
                    <th>Actions</th>
                </tr>
            </thead>
            <tbody>
                {Object.entries(modal.data).map(([key, attribute], index) => (
                    <tr key={index} className={getAttributeRowClass(key)}>
                         <td>
                            {attribute.istax === "no" ? (
                                <input
                                    type="text"
                                    value={attribute.label}
                                    onChange={(e) => handleLabelChange(key, e.target.value)}
                                    className="attribute-label-input"
                                    placeholder="Enter label"
                                />
                            ) : (
                                <strong>{attribute.label}</strong>
                            )}
                        </td>
                        <td>
                            {attribute.istax === "yes" ? (
                                Array.isArray(attribute.all_attirbute) ? (
                                    attribute.all_attirbute.map((attr, attrIndex) => {
                                        const isChecked = (attribute.values || []).includes(attr.term_id);
                                        return (
                                            <div key={attrIndex} className="attribute-checkbox">
                                                <input
                                                    type="checkbox"
                                                    checked={isChecked}
                                                    onChange={() => toggleAttribute(key, attr.term_id)}
                                                />
                                                {attr.name}
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p>No attributes available</p>
                                )
                            ) : (
                                <input
                                    type="text"
                                    placeholder="Enter value"
                                    value={attribute.values || ""}
                                    onChange={(e) => handleAttributeChange(key, e.target.value)}
                                    className="attribute-input"
                                />
                            )}
                        </td>
                        <td>{renderCheckbox("", "visible", key, attribute)}</td>
                        <td>{renderCheckbox("", "variation", key, attribute)}</td>
                        <td>
                            <button className="attribute-delete-button" onClick={() => deleteAttribute(key)}>
                                Delete
                            </button>
                        </td>
                    </tr>
                ))}
            </tbody>
        </table>
        </>
    );
};

export default AttributeEditor;
